export default "__VITE_ASSET__rAqiKJnQ__"